import axios from 'axios';

export const dropZoneimageUploader = async (file, sku) => {
  let url = `https://api.cloudinary.com/v1_1/botics-ai/image/upload/`;
  const formData = new FormData();

  try {
    formData.append('file', file);

    const response = await axios.post(
      url,
      formData,
      {
        params: {
          folder: `tmr/organisation/client/logo/images`,
          upload_preset: process.env.REACT_APP_CLOUD_FLARE_UPLOAD_PRESET,
          cloud_name: process.env.REACT_APP_CLOUD_FLARE_NAME,
        },
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return { image: response.data?.secure_url };
  } catch (error) {
    return error;
  }
};
